import React from 'react';
import { useNavigate } from 'react-router-dom';

const StudentIndex = () => {

    const navigate = useNavigate();

  const handleApplyClick = () => {
    navigate('/student/register');
  };

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Welcome to Student Fee Assistance</h1>
            <p style={styles.subHeading}>
                Making education affordable for every student. Get help with your fees, apply for assistance, and secure your future.
            </p>
            <p style={styles.description}>
                We understand that paying fees can be a challenge, and we're here to help. Whether you need assistance with tuition, accommodation, or other expenses, we provide tailored support to help you achieve your academic goals without financial stress.
            </p>
            <button style={styles.applyButton} 
              onMouseEnter={(e) => Object.assign(e.target.style, styles.hover)}
              onMouseLeave={(e) => Object.assign(e.target.style, styles.applyButton)} 
            onClick={handleApplyClick} >Apply & Register</button>
        </div>
    );
};

// Inline styles for quick implementation
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '50px',
        backgroundColor: '#F6F8FA',
        minHeight: '100vh',
        color: '#1A1A1A',
    },
    heading: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        color: '#1A73E8', // Theme primary color
        marginBottom: '20px',
    },
    subHeading: {
        fontSize: '1.5rem',
        color: '#333333',
        marginBottom: '15px',
    },
    description: {
        fontSize: '1rem',
        color: '#5A5A5A',
        maxWidth: '600px',
        lineHeight: '1.6',
        marginBottom: '30px',
    },
    applyButton: {
        backgroundColor: '#E60240', // Accent color from the theme
        color: '#FFFFFF',
        padding: '12px 30px',
        fontSize: '1rem',
        fontWeight: '600',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
    },

    hover: {
        backgroundColor: '#c20035', // Darker red on hover
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
      },
};

export default StudentIndex;
